import { FC, SVGProps } from 'react';

export const ClickIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M12.2177 12.4624L16.553 26.6486C16.8623 27.6606 18.3261 27.5616 18.4964 26.5172L19.4461 20.6899C19.5085 20.307 19.7867 19.9948 20.1599 19.8888L26.6881 18.0345C27.6512 17.7609 27.6592 16.3988 26.6994 16.1139L12.7141 11.962C12.4083 11.8712 12.1245 12.1573 12.2177 12.4624Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinejoin="round"
		/>
		<path d="M15.9131 7.40218L18.4033 4.91193" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		<path d="M11 5.75V2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		<path d="M7.69565 7.40218L5.2054 4.91193" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		<path d="M7 11.75L3 11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		<path d="M7.69565 15.6196L5.2054 18.1098" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);
